import googleLibPhoneNumber, { PhoneNumberType } from 'google-libphonenumber'
// ref. https://github.com/ruimarinho/google-libphonenumber

function createGoogleLibPhoneNumber () {
  const phoneUtil = googleLibPhoneNumber.PhoneNumberUtil.getInstance()

  const deviceRegionCode = navigator.language.toLocaleUpperCase()
  const defaultRegionCode = phoneUtil.getSupportedRegions().find(code => deviceRegionCode.includes(code)) || 'TW'

  /**
   * 是否可能是電話號碼
   * returns true if the number is either a possible fully-qualified number (containing the area code and country code),
   * or if the number could be a possible local number (with a country code, but missing an area code).
   */
  function isPossibleNumber (phone, regionCode = defaultRegionCode) {
    try {
      if (!phone) {
        return false
      }
      const number = phoneUtil.parseAndKeepRawInput(phone, regionCode)
      return phoneUtil.isPossibleNumber(number)
    } catch (error) {
      console.log(error)
      return false
    }
  }

  /**
   * 是否為合法的號碼
   * tests whether a phone number matches a valid pattern.
   */
  function isValidNumber (phone, regionCode = defaultRegionCode) {
    try {
      if (!phone) {
        return false
      }
      const number = phoneUtil.parseAndKeepRawInput(phone, regionCode)
      return phoneUtil.isValidNumber(number)
    } catch (error) {
      console.log(error)
      return false
    }
  }

  /**
   * 是否為合法的「手機」號碼
   */
  function isValidMobileNumber (phone, regionCode = defaultRegionCode) {
    try {
      if (!phone) {
        return false
      }
      const number = phoneUtil.parseAndKeepRawInput(phone, regionCode)
      return (
        phoneUtil.isValidNumber(number) &&
        [PhoneNumberType.MOBILE, PhoneNumberType.FIXED_LINE_OR_MOBILE, PhoneNumberType.PERSONAL_NUMBER].includes(phoneUtil.getNumberType(number))
      )
    } catch (error) {
      console.log(error)
      return false
    }
  }

  /**
   * 取得國際格式電話號碼
   */
  function toInternationalFormat (phone, regionCode = defaultRegionCode) {
    try {
      if (!phone) {
        return ''
      }
      const number = phoneUtil.parseAndKeepRawInput(phone, regionCode)
      const extension = number.getExtension() || ''
      return `+${number.getCountryCode()} ${number.getNationalNumber()}${extension ? `,${extension}` : ''}`
    } catch (error) {
      console.log(error)
      return ''
    }
  }

  /**
   * 透過區碼（ex: 886）取得國家代碼（ex: TW）
   */
  function getRegionCodeForCountryCode (callingCode = defaultRegionCode) {
    try {
      if (!callingCode) {
        return ''
      }
      return phoneUtil.getRegionCodeForCountryCode(callingCode)
    } catch (error) {
      console.log(error)
      return ''
    }
  }

  /**
   * 透過國家代碼（ex: TW）取得區碼（ex: 886）
   */
  function getCountryCodeForRegion (regionCode) {
    try {
      if (!regionCode) {
        return ''
      }
      return `${phoneUtil.getCountryCodeForRegion(regionCode)}`
    } catch (error) {
      console.log(error)
      return ''
    }
  }

  return {
    isPossibleNumber,
    isValidNumber,
    isValidMobileNumber,
    toInternationalFormat,
    getRegionCodeForCountryCode,
    getCountryCodeForRegion,
    getSupportedRegions: phoneUtil.getSupportedRegions
  }
}

export const phoneHelpers = createGoogleLibPhoneNumber()
